export class AutoOutgoingRule {
  id: number;
  intranet_id: number;
  matter_id: number;
  document_type_id: number;
  role_type_id: number;
  first_involvement_only: boolean = false;
  way: string;
  created_by: any;
  updated_by: any;
  created_at: any;
  updated_at: any;
  minimum_priority: number = 10;
  way_str: string;
  role_type_name: string;
  document_type_name: string;
  matter_full_name: string;
}
